import { Instance, types } from 'mobx-state-tree'

export const LiveModel = types.model('Live').props({
  id: types.identifier,
  title: types.string,
  image: types.string,
  url: types.string,
  spekeSignature: types.maybe(
    types.model('SpekeSignature').props({
      keyPairId: types.string,
      policy: types.string,
      signature: types.string,
    }),
  ),
  expiryDate: types.maybe(types.string),
  published: types.boolean,
})

export type Live = Instance<typeof LiveModel>
